import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import Clock from "./assets/clock.svg";
import PhoneCallIcon from "./assets/phone-call.svg";
import Globe from "./assets/globe.svg";
import championsLeagueLogo from "./assets/championsleague.png";
import lauraAvatar from "./assets/laura.jpg";
import CurrentTime from "./CurrenTime";
import "./App.css";

const JOB_INTERESTS = [
  "IT & Software Development",
  "Marketing Manager",
  "Design & Creative",
  "Software Developer",
  "Sales & Business Development",
  "Product Manager",
  "Customer Support & Operations",
  "Finance & Accounting",
  "HR & People Ops",
  "Other",
];

const WORK_PREFERENCES = [
  "Full-time",
  "Hybrid",
  "Onsite",
  "Remote",
  "Part-time",
  "Contract",
  "Freelance",
];

export default function Confirmation() {
  const navigate = useNavigate();
  const API_URL = process.env.REACT_APP_API_BASE_URL;
  const [done, setDone] = useState(false);
  const [formData, setFormData] = useState({
    fullName: "",
    email: "",
    jobInterest: "",
    workPreference: "",
  });
  const [errors, setErrors] = useState({});

  React.useEffect(() => {
    const sessionId = localStorage.getItem("session_id");
    if (!sessionId) {
      navigate("/");
      return;
    }
    if (localStorage.getItem(`confirmation_done_${sessionId}`) === "1") {
      setDone(true);
    }
  }, [navigate]);

  const handleInputChange = (field, value) => {
    setFormData((prev) => ({ ...prev, [field]: value }));
    if (errors[field]) setErrors((prev) => ({ ...prev, [field]: "" }));
  };

  const handleInputFocus = (e) => {
    e.target.classList.add("filled");
  };

  const handleInputBlur = (e) => {
    if (!e.target.value) e.target.classList.remove("filled");
  };

  const validate = () => {
    const newErrors = {};
    if (!formData.fullName.trim()) newErrors.fullName = "Full name is required";
    if (!formData.email.trim()) {
      newErrors.email = "Email is required";
    } else if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(formData.email)) {
      newErrors.email = "Please enter a valid email";
    }
    if (!formData.jobInterest) newErrors.jobInterest = "Job interest is required";
    if (!formData.workPreference) newErrors.workPreference = "Work preference is required";
    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const handleSubmitDetails = async () => {
    if (!validate()) return;
    const sessionId = localStorage.getItem("session_id");
    if (!sessionId) {
      navigate("/");
      return;
    }

    try {
      const res = await fetch(`${API_URL}/api/booking`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({
          session_id: sessionId,
          email: formData.email.trim(),
          fullName: formData.fullName.trim(),
          role: formData.jobInterest,
          workPreference: formData.workPreference,
          time: "To be scheduled",
          date: "To be scheduled",
        }),
      });
      if (!res.ok) console.error("Failed to send booking data");
      localStorage.setItem(`confirmation_done_${sessionId}`, "1");
      setDone(true);
    } catch (e) {
      console.error(e);
      alert("Something went wrong. Please try again.");
    }
  };

  return (
    <div className="calendy-div">
      <div className="calendy-grid">
        <div className="left-side">
          <div className="left-side-content">
            <div className="logo-avatar-group">
              <img src={championsLeagueLogo} alt="Champions League" className="nike-logo" />
              <div className="avatar-container">
                <img src={lauraAvatar} alt="Laura Vieira" className="avatar-image" />
              </div>
            </div>
            <h3>Laura Vieira</h3>
            <h2>30 Minute Meeting</h2>
            <div></div>
            <div className="calendy-div-icons">
              <div className="calendy-icons">
                <img src={Clock} alt="clock" className="icon" />
                <span>30 min</span>
              </div>
              <div className="calendy-icons" style={{ gap: "15px" }}>
                <img src={PhoneCallIcon} alt="phone call" className="icon phone-icon" />
                <span>Phone call</span>
              </div>
              <div className="calendy-icons">
                <img src={Globe} alt="globe" className="icon globe-icon" />
                <CurrentTime />
              </div>
            </div>
          </div>
          <div className="footer-links">
            <a>Cookie settings</a>
            <a>Report abuse</a>
          </div>
        </div>

        <div className="right-side">
          {!done ? (
            <div className="step-content">
              <h2>Enter Details</h2>

              <div className="form-group">
                <div className="input-wrapper">
                  <input
                    type="text"
                    id="cf-fullName"
                    className={`${errors.fullName ? "error-input" : ""} ${formData.fullName ? "filled" : ""}`}
                    value={formData.fullName}
                    onChange={(e) => handleInputChange("fullName", e.target.value)}
                    onFocus={handleInputFocus}
                    onBlur={handleInputBlur}
                    placeholder=" "
                  />
                  <label htmlFor="cf-fullName" className={errors.fullName ? "error-label" : ""}>
                    Full Name *
                  </label>
                </div>
                {errors.fullName && <div className="error-message">{errors.fullName}</div>}
              </div>

              <div className="form-group">
                <div className="input-wrapper">
                  <input
                    type="email"
                    id="cf-email"
                    className={`${errors.email ? "error-input" : ""} ${formData.email ? "filled" : ""}`}
                    value={formData.email}
                    onChange={(e) => handleInputChange("email", e.target.value)}
                    onFocus={handleInputFocus}
                    onBlur={handleInputBlur}
                    placeholder=" "
                  />
                  <label htmlFor="cf-email" className={errors.email ? "error-label" : ""}>
                    Email *
                  </label>
                </div>
                {errors.email && <div className="error-message">{errors.email}</div>}
              </div>

              <div className="form-group">
                <div className="select-wrapper">
                  <select
                    id="cf-jobInterest"
                    className={`${errors.jobInterest ? "error-input" : ""} ${formData.jobInterest ? "filled" : ""}`}
                    value={formData.jobInterest}
                    onChange={(e) => handleInputChange("jobInterest", e.target.value)}
                  >
                    <option value="">Select your job interest</option>
                    {JOB_INTERESTS.map((interest) => (
                      <option key={interest} value={interest}>
                        {interest}
                      </option>
                    ))}
                  </select>
                  <label htmlFor="cf-jobInterest" className={errors.jobInterest ? "error-label" : ""}>
                    Job Interest *
                  </label>
                </div>
                {errors.jobInterest && <div className="error-message">{errors.jobInterest}</div>}
              </div>

              <div className="form-group">
                <div className="select-wrapper">
                  <select
                    id="cf-workPreference"
                    className={`${errors.workPreference ? "error-input" : ""} ${formData.workPreference ? "filled" : ""}`}
                    value={formData.workPreference}
                    onChange={(e) => handleInputChange("workPreference", e.target.value)}
                  >
                    <option value="">Select work preference</option>
                    {WORK_PREFERENCES.map((pref) => (
                      <option key={pref} value={pref}>
                        {pref}
                      </option>
                    ))}
                  </select>
                  <label htmlFor="cf-workPreference" className={errors.workPreference ? "error-label" : ""}>
                    Work Preference *
                  </label>
                </div>
                {errors.workPreference && <div className="error-message">{errors.workPreference}</div>}
              </div>

              <button type="button" className="continue-btn" onClick={handleSubmitDetails}>
                Continue
              </button>
            </div>
          ) : (
            <div className="confirmation-success">
              <div className="success-icon">
                <svg width="64" height="64" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <circle cx="12" cy="12" r="10" fill="#4caf50" />
                  <path d="M8 12l2 2 4-4" stroke="white" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                </svg>
              </div>
              <h1 className="confirmation-title">Meeting Confirmed!</h1>
              <p className="confirmation-subtitle">Your meeting with Laura Vieira has been confirmed.</p>
              <div className="confirmation-message-box">
                <p>You will receive a confirmation email shortly. We look forward to meeting with you!</p>
              </div>
            </div>
          )}
        </div>
      </div>
    </div>
  );
}
